const getPreviewUrl = function () {
  return process.env.REACT_APP_ComeToLifeUrl || '';
};

const getStorageUrl = function () {
  return process.env.REACT_APP_GCP_STORAGE_EXP_URL || '';
};

export { getStorageUrl, getPreviewUrl as default };
